import React from 'react';

export default (...args) => {
  let name, component;

  if (args.length === 1) {
    name = 'Unknown component';
    component = args[0];
  } else {
    name = args[0];
    component = args[1];
  }

  if (process.env.NODE_ENV !== 'development') {
    return component;
  }

  const wrapper = props => {
    console.log(`${name} props are`, props);
    return React.createElement(component, props);
  };
  return wrapper;
};
